
// === Custom Gallery

window.addEventListener('DOMContentLoaded', (event) => {

  const customGalleryMedias = document.querySelectorAll('[data-custom-gallery] [data-product-custom-image]');
  const customGalleryAllMedias = document.querySelectorAll('[data-custom-gallery-all] [data-product-custom-image]');
  const readyImagesZoom = new Event("readyImagesZoom");

  if (customGalleryMedias.length > 0 && customGalleryAllMedias.length > 0) {

    // === Main Function

    function customGallery() {

      const thisVariantOptionsElem = document.querySelector('[data-custom-gallery][data-variant-options]');
      let thisVariantOptions = null;
      if (thisVariantOptionsElem !== null && thisVariantOptionsElem !== undefined) {
        thisVariantOptions = thisVariantOptionsElem.getAttribute('data-variant-options');
      }

      if (thisVariantOptions !== null && thisVariantOptions !== undefined && thisVariantOptions.length > 0) {

        // === Show images who match with selected variant

        if (thisVariantOptions.includes('||')) {
          thisVariantOptions = thisVariantOptions.split('||');
        } else {
          thisVariantOptions = [thisVariantOptions];
        }

        let matchingImages = [];
        customGalleryAllMedias.forEach(initialMedia => {

          let mediaAlt = initialMedia.getAttribute('data-media-alt');
          if (mediaAlt !== null && mediaAlt !== undefined && mediaAlt.length > 0) {

            let thisImageMatch = false;

            if (mediaAlt.includes('##')) {

              // --- Match with several options and has different options combination
              let options_combinaison = mediaAlt.split('##');
              options_combinaison.forEach(combinaison => {

                let need_options = combinaison.split(',');
                let option_match_count = 0;
                thisVariantOptions.forEach(option => {
                  if (need_options.includes(option)) {
                    option_match_count++;
                  }
                });
                if (need_options.length == option_match_count) {
                  thisImageMatch = true;
                }
                
              });
              
            } else if (mediaAlt.includes(',')) {

              // --- Match with several options
              let need_options = mediaAlt.split(',');
              let option_match_count = 0;
              thisVariantOptions.forEach(option => {
                if (need_options.includes(option)) {
                  option_match_count++;
                }
              });
              if (need_options.length == option_match_count) {
                thisImageMatch = true;
              }

            } else {

              // --- Match with one option
              thisVariantOptions.forEach(option => {
                if (mediaAlt == option) {
                  thisImageMatch = true;
                }
              });
              
            }

            // [OLD]
            // thisVariantOptions.forEach(option => {
            //   if (mediaAlt == option) {
            //     thisImageMatch = true;
            //   }
            // });

            if (thisImageMatch) {
              matchingImages.push(initialMedia.innerHTML);
            }
            
          }
          
        });

        if (matchingImages.length > 0) {

          // Show matching image(s)

          customGalleryMedias.forEach((media, index) => {

            media.innerHTML = '';
    
            if (matchingImages[index] !== null && matchingImages[index] !== undefined) {
              media.innerHTML = matchingImages[index];
              media.classList.remove('hide');
            } else {
              media.classList.add('hide');
            }
            
          });
          
        } else {

          // Show all images

          customGalleryMedias.forEach((media, index) => {

            if (customGalleryAllMedias[index] !== null && customGalleryAllMedias[index] !== undefined) {
              media.innerHTML = customGalleryAllMedias[index].innerHTML;
              media.classList.remove('hide');
            } else {
              media.classList.add('hide');
            }
    
          });

        }

      } else {

        // Show all images

        customGalleryMedias.forEach((media, index) => {

          if (customGalleryAllMedias[index] !== null && customGalleryAllMedias[index] !== undefined) {
            media.innerHTML = customGalleryAllMedias[index].innerHTML;
            media.classList.remove('hide');
          } else {
            media.classList.add('hide');
          }
  
        });

      }

      // New event ready for image zoom init
      document.dispatchEvent(readyImagesZoom);
      
    }

    // === Init

    customGallery();


    // === On variant change

    document.addEventListener(
      "variantChange",
      (e) => {
        customGallery();
      },
      false
    );

    // === Init sticky
    function initSticky() {
      let stickyTop = 10;

      const header = document.getElementById('Header-header');
      if (header !== null && header !== undefined) {
        stickyTop += header.offsetHeight;
      }

      const stickyAddToCart = document.querySelector('#product-sticky .product_desk-sticky-bar');
      if (stickyAddToCart !== null && stickyAddToCart !== undefined) {
        stickyTop += stickyAddToCart.offsetHeight;
      }

      // Sticky: product infos
      const productInfosSticky = document.querySelector('.product_infos-sticky');
      if (productInfosSticky !== null && productInfosSticky !== undefined) {
        productInfosSticky.style.top = stickyTop + 'px';
      }

      // Sticky: custom gallery
      const customGallerySticky = document.querySelector('[data-custom-gallery]');
      if (customGallerySticky !== null && customGallerySticky !== undefined) {
        customGallerySticky.style.top = stickyTop + 'px';
      }

      // Sticky: main gallery
      const mainGallerySticky = document.querySelector('[product-main-gallery]');
      if (mainGallerySticky !== null && mainGallerySticky !== undefined) {
        mainGallerySticky.style.top = stickyTop + 'px';
      }
    }
    if (window.innerWidth > 800) {
      
      initSticky();
      window.addEventListener('load', function() {
        initSticky();
      });
      
    }
    
  }

});